import { Component, ChangeDetectionStrategy } from '@angular/core';
import { IonSpinner } from '@ionic/angular/standalone';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-spinner-loading',
  templateUrl: './spinner-loading.component.html',
  styleUrls: ['./spinner-loading.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IonSpinner, TranslateModule],
})
export class SpinnerLoadingComponent {
  // constructor() {}
}
